<div class="rs-switch" *ngIf="option && !loading && !isPendingInCart">
  <input
    role="switch"
    aria-checked="false"
    type="checkbox"
    id="{{ 'switch-' + option.optionCodeForDescription }}"
    name="switch"
    [checked]="active"
    (click)="addToCart()"
    [disabled]="(!isWebshopCartInit || pendingOrder) && !isExceedingAlarmThresholdOption()"
  />
  <label
    for="{{ 'switch-' + option.optionCodeForDescription }}"
    attr.aria-labelledby="ac-switch-text{{ option.optionCodeForDescription }}"
  >
    <span class="rs-switch-active" aria-hidden="true">{{ 'order.switch.yes' | translate }}</span>
    <span class="rs-switch-inactive" aria-hidden="true">{{ 'order.switch.no' | translate }}</span>
  </label>
</div>

<div *ngIf="isWebshopCartInit && (loading || isPendingInCart)">
  <px-loading-spinner class="rs-margin-right1"></px-loading-spinner>
</div>
